/* eslint-disable no-bitwise */
// ImpactAnalysis.tsx
import React from 'react';
import {
  Container,
  GroupName,
  GroupQuestions,
  GroupRow,
  GroupSliders,
  QuestionText,
  ScaleLabels,
  Separator,
  SliderBar,
  SliderMarker,
} from './styles';

interface Question {
  questionId: number;
  questionText: string;
  average: number;
}

interface Group {
  groupId: number;
  groupName: string;
  color: string;
  questions: Question[];
}

interface ImpactAnalysisProps {
  data: Group[];
}

const hexToRgba = (hex: string, alpha: number): any => {
  let c = hex.replace('#', '');
  if (c.length === 3)
    c = c
      .split('')
      .map(x => x + x)
      .join('');
  const n = parseInt(c, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const ImpactAnalysis: React.FC<ImpactAnalysisProps> = ({ data }) => {
  const getMarkerPosition = (avg: number): number =>
    ((avg - 1) / (5 - 1)) * 100;

  console.log(data);
  return (
    <Container>
      {data.map(group => {
        const groupBg = hexToRgba(group.color, 0.14);
        const lineColor = hexToRgba(group.color, 0.9);

        return (
          <GroupRow key={group.groupId}>
            <GroupName color={group.color}>{group.groupName}</GroupName>

            <GroupQuestions bg={groupBg}>
              {group.questions.map((q, idx) => (
                <React.Fragment key={q.questionId}>
                  <QuestionText>{q.questionText}</QuestionText>
                  {idx < group.questions.length - 1 && (
                    <Separator color={lineColor} />
                  )}
                </React.Fragment>
              ))}
            </GroupQuestions>

            <GroupSliders bg={groupBg}>
              {group.questions.map(q => (
                <div key={q.questionId}>
                  <SliderBar>
                    <SliderMarker
                      position={getMarkerPosition(q.average)}
                      data-value={`Avg: ${q.average.toFixed(2)}`}
                    />
                  </SliderBar>
                  <ScaleLabels>
                    <span>Low</span>
                    <span>Medium</span>
                    <span>High</span>
                  </ScaleLabels>
                </div>
              ))}
            </GroupSliders>
          </GroupRow>
        );
      })}
    </Container>
  );
};
